<template>
    <div v-show="isLoaded" class="mOthersRose-container" v-observe-visibility="startAnimate">
        <div class="mOthersRose-title">
            <h2 class="Others-title" :class="{animate: animate}">Conoce <br> <span class="title-span">Otros <span class="subtitle-span">Sabores</span></span></h2>
        </div>
        <div class="mOthersRose-sku">
            <div class="mRow">
                <router-link
                    :to="{name: 'goldApple'}"
                    :class="{animate: animate}"
                >
                    <img class="bottle-mobile gold" :src="gold" alt="Gold Apple" />
                    <img class="bottle-desktop" :src="desktopgold" alt="Gold Apple" />
                    
                </router-link>
                <router-link
                    :to="{name: 'honey'}"
                    :class="{animate: animate}"
                >
                    <img class="bottle-mobile" :src="honey" alt="Honey" />
                    <img class="bottle-desktop" :src="desktophoney" alt="Honey" />
                    
                </router-link>
                <router-link
                    :to="{name: 'redBerries'}"
                    :class="{animate: animate}"
                >
                    <img class="bottle-mobile" :src="redberries" alt="Red Berries" />
                    <img class="bottle-desktop" :src="desktopred" alt="Red Berries" />
                    
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import gold from "@/assets/GOLD.png";
import honey from "@/assets/HONEY.png";
import redberries from "@/assets/RED_BERRIES.png";
import desktopgold from "@/assets/desktop_goldapple.png";
import desktophoney from "@/assets/desktop_honey.png";
import desktopred from "@/assets/desktop_redberries.png";
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
    name: "OthersRose",
    data() {
        return {
            gold,
            honey,
            redberries,
            desktopgold,
            desktophoney,
            desktopred,
            animate: false,
            isSafari: false,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        }
    },
    components: { },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/RoseApple/OthersRose.scss";
</style>